import { Col,Button } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl,link }) => {

  const btnClick = ()=>{
    window.open(link, '_blank');
  }
  return (
    <Col size={12} sm={6} md={4}>
      <button onClick={btnClick}>
      <div className="proj-imgbx">
        <img src={imgUrl} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
      </button>
    </Col>
  )
}
